export const state = () => ({
})

export const mutations = {
}

export const actions = {
  changeWithdrawPeriod ({ rootState }, payload) {
    const formData = new FormData()
    formData.append('WithdrawalPeriod', payload.period)
    formData.append('Token', payload.token)
    return new Promise((resolve, reject) => {
      this.$axios.post(`${process.env.BASE_API_V4}doctor/wallet/period/update`, formData, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error.response)
      })
    })
  },
  getWalletIncome ({ rootState }, data) {
    const { type, params } = data
    return new Promise((resolve, reject) => {
      this.$axios.get(`${process.env.BASE_API_V4}doctor/wallet/${type}/income?${params}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getWalletPending ({ rootState }, data) {
    const { type, params } = data
    return new Promise((resolve, reject) => {
      this.$axios.get(`${process.env.BASE_API_V4}doctor/wallet/${type}/pending?${params}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getWalletReady ({ rootState }, data) {
    const { type, params } = data
    return new Promise((resolve, reject) => {
      this.$axios.get(`${process.env.BASE_API_V4}doctor/wallet/${type}/ready?${params}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getWalletSuccess ({ rootState }, data) {
    const { type, params } = data
    return new Promise((resolve, reject) => {
      this.$axios.get(`${process.env.BASE_API_V4}doctor/wallet/${type}/success?${params}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getWalletWithdraw ({ rootState }, data) {
    const { type, params } = data
    return new Promise((resolve, reject) => {
      this.$axios.get(`${process.env.BASE_API_V4}doctor/wallet/${type}/success?${params}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getDetailSuccessWithdraw ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      const { type, limit, page, detailId, token } = payload
      this.$axios.get(process.env.BASE_API_V4 + 'doctor/wallet/success/detail/' + detailId + `?Type=${type}&Limit=${limit}&page=${page}&Token=${token}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  markVerification ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + 'doctor/wallet/income/accept/' + payload.id + `&Token=${payload.token}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  checkAccountBank ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + `payment/bank/check?BankID=${payload.BankID}&AccountNumber=${payload.AccountNumber}&AccountName=${payload.AccountName}&BankType=BANK_ACCOUNT`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getPDFSuccessTransaction ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + `doctor/wallet/pdf/detail/${payload.transactionId}?Type=${payload.typeDoctor}&Token=${payload.token}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getDetailSuccessTransaction ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + `doctor/wallet/success/detail/${payload.transactionId}${payload.params}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}
